import {React, observer, classNames, Fragment} from '@api'
import {Icon} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {DetailViewLocationIconButton, useCatalogItemSidebarDetailsStore} from '@modules'
import {CatalogSearchBar} from '@modules/catalogSearcher/CatalogSearchBar'
import {ModalCatalogItemSeasonSelectors} from '@modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalCatalogItemSeasonSelectors'
import {IFlexLayoutInlineCatalogItemDetailsConfig, useVipFlexLayoutTabStore} from '@stores/catalog'
import {LibrarySidebarTabs, PrimaryIconButton} from 'centric-ui-components'
import {CatalogItemModelH1, CatalogItemModelH2, CatalogItemModelLastSync, CatalogItemStatus, CatalogItemSwitch, CatalogItemModeColorType} from './PrimaryDetails'
import * as css from './ModalHeader.css'
import {Tooltip} from '@material-ui/core'
import {CatalogOpenInC8} from './CatalogOpenInC8'

import {CatalogFieldRenderer} from '@lazy'

export const CatalogItemModalHeader = observer<React.HTMLProps<HTMLDivElement>>(({className, ...props}) => {
  const {strings, stores: {catalog, sidebar: {left}}, sidebar: {inlineModal, toggleOpen}, detailDef: {modal}, associatedWorkspace} = useCatalogItemSidebarDetailsStore(),
    vipTab = useVipFlexLayoutTabStore()

  return (
    <div className={classNames(css.root, className)}
         data-type='ModalHeader'
         data-grid-area='header' {...props}>
      <div data-align='left'>
        {inlineModal && <Fragment>
          {!left.open &&
		   <div className={css.libraryTabs}>
			   <LibrarySidebarTabs/>
		   </div>
          }
			<Tooltip2 content={`${_.capitalize(strings.goBack)}`} position='bottom'>
				<PrimaryIconButton wrapperClassName={css.goBack} onClick={toggleOpen} icon={<Icon icon='arrow-left'/>}/>
			</Tooltip2>
		</Fragment>}

        {/*<span className={css.itemNoun}>{associatedWorkspace?.catalog?.catalogItemName}</span>*/}
        <CatalogItemModelH1/>
        <CatalogItemModelH2/>
      </div>
      {modal?.customCenterHeaderSections && <div data-align='center'>
		  <CatalogItemModeColorType/>
	  </div>}
      <div data-align='right'>
        <CatalogItemStatus/>
        <CatalogItemSwitch/>
        <ModalCatalogItemSeasonSelectors className={css.seasonSelectors}/>
        {modal?.header?.fields?.map(field => <CatalogFieldRenderer field={field} key={field.field}/>)}
        <CatalogItemModelLastSync/>
        {catalog?.detailViewFor(catalog?.index).modal?.searchBar && <CatalogSearchBar inModal className={css.searchBar}/>}
        {/*<DetailsModalSearch />*/}

        <DetailPaneOrientationToggleButton/>
        <CatalogOpenInC8/>
        {vipTab?.tab?.isMaximized && <DetailViewLocationIconButton/>}

        {!inlineModal && <Tooltip2 content={`${_.capitalize(strings.close)} ${_.capitalize(strings.details)}`}>
			<PrimaryIconButton wrapperClassName={css.closeButton} onClick={toggleOpen} icon={<Icon icon='cross'/>}/>
		</Tooltip2>}

        {/*<Tooltip2 content={`Close`}>*/}
        {/*  <PrimaryIconButton icon={<Icon icon='cross' />} className={css.closeLink} onClick={sidebar.right.toggleOpen} />*/}
        {/*</Tooltip2>*/}
      </div>
    </div>)
})

export const DetailPaneOrientationToggleButton = observer(function DetailPaneOrientationToggleButton() {
  const {orientation, toggleOrientation} = useCatalogItemSidebarDetailsStore()

  return (<PrimaryIconButton
    icon={orientation === 'horz' ? 'arrows-horizontal' : 'arrows-vertical'}
    onClick={toggleOrientation}
    tooltip='Change Panel Orientation'
  tooltipStyle='mui'
  tooltipPosition='bottom'/>)
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalHeader.tsx